import { Controller } from "@hotwired/stimulus"

// Collapsible overlay group on the Stream-overlays settings section.
// Persists open/closed state to localStorage keyed by data-overlay-group-storage-key-value
// so the group survives Turbo re-renders (autosave redirect, frame swap, etc.).
//
//   <div data-controller="overlay-group"
//        data-overlay-group-storage-key-value="overlay-group:Scenes">
//     <button data-action="click->overlay-group#toggle">...</button>
//     <div data-overlay-group-target="chevron">...</div>  <!-- rotated when open -->
//     <div data-overlay-group-target="body" class="hidden">...</div>
//   </div>
export default class extends Controller {
  static targets = ["body", "chevron"]
  static values = { storageKey: String }

  connect() {
    // Restore from localStorage; default to open so groups are visible on first load.
    const stored = this.storageKeyValue
      ? localStorage.getItem(this.storageKeyValue)
      : null
    if (stored === "closed") {
      this._setOpen(false, false)
    } else {
      this._setOpen(true, false)
    }
  }

  toggle() {
    const isOpen = !this.bodyTarget.classList.contains("hidden")
    this._setOpen(!isOpen, true)
  }

  _setOpen(open, persist) {
    this.bodyTarget.classList.toggle("hidden", !open)
    this.chevronTarget.style.transform = open ? "rotate(90deg)" : ""
    if (persist && this.storageKeyValue) {
      localStorage.setItem(this.storageKeyValue, open ? "open" : "closed")
    }
  }
}
